import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Note from "components/common/note";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import useWindowSize from "hooks/useWindowSize";
import React, { useState } from "react";
import { TableVirtuoso } from "react-virtuoso";
import MainTableRow from "./MainTableRow";

const ExpandableRow = ({ context, item: row, ...restProps }) => {
  return <MainTableRow {...restProps} {...context} key={row.id} row={row} />;
};

const TableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => <Table {...props} style={{ borderCollapse: "separate" }} />,
  TableHead: TableHead,
  TableRow: ExpandableRow,
  TableBody: React.forwardRef((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};

const MainTable = ({
  setAllLeads,
  allLeads,
  handleDelete,
  setReload,
  pagination,
  setPagination,
  loading,
  handleTableCheckBox,
  selectedRows,
  permissions,
}) => {
  const { isMini, isSuperMini } = useWindowSize();
  const [openNote, setOpenNote] = useState("");
  const rows = allLeads;
  const columns = [
    { id: "name", label: "Name", style: { width: "190px" } },
    { id: "phone", label: "Phone", style: { width: "190px" } },
    { id: "email", label: "Email", style: { width: "190px" } },
    { id: "lead_assignees", label: "Assigned", align: "center" },
    { id: "followup_date", label: "Followup Date", style: { width: "150px" } },
    { id: "last_note", label: "Notes", style: { width: "190px" } },
    {
      id: "lead_preferred_countries",
      label: "Preferred Countries",
      style: { width: "190px" },
    },

    { id: "source", label: "Source", style: { width: "100px" } },
    { id: "lead_status", label: "Status" },
    {
      id: "action",
      label: "Actions",
      style: { width: "170px" },
      align: "center",
    },
  ];

  const height = isMini ? "calc(100vh - 201px)" : "calc(100vh - 257px)";
  if (isMini) columns.splice(3, columns?.length - 4);
  if (isSuperMini) columns.splice(1, columns?.length - 2);

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
      {!loading ? (
        <TableContainer
          sx={{
            height,
            overflowX: "auto",
          }}
        >
          <TableVirtuoso
            style={{ height }}
            data={rows}
            components={TableComponents}
            context={{
              columns,
              handleDelete,
              openNote,
              setOpenNote,
              handleTableCheckBox,
              selectedRows,
              permissions,
              setReload,
              allLeads,
              setAllLeads,
            }}
            fixedHeaderContent={() => (
              <TableRow
                sx={{
                  "& .MuiTableCell-sizeMedium": {
                    padding: "10px 0px 10px 16px",
                  },
                  "& .MuiTableCell-sizeMedium:first-of-type": {
                    paddingLeft: "8px",
                    paddingRight: "0px",
                  },
                }}
              >
                <TableCell padding="checkbox" sx={{ bgcolor: "#fff" }}>
                  <Checkbox
                    disabled={!permissions["bulk action"] || isMini}
                    checked={
                      selectedRows?.length === rows?.length && rows?.length
                    }
                    onChange={(e) =>
                      handleTableCheckBox("all", e.target.checked)
                    }
                  />
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    sx={{ bgcolor: "#fff" }}
                    key={column.id}
                    align={column.align}
                    style={column.style}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            )}
          />
        </TableContainer>
      ) : (
        <TableSkeleton columns={columns} tableHeight={height} />
      )}
      <TablePagination
        span={columns?.length}
        setReload={setReload}
        pagination={pagination}
        setPagination={setPagination}
      />
      {openNote && (
        <Note
          open={openNote}
          handleClose={() => setOpenNote(false)}
          id={openNote}
          related_id={openNote}
          related_to="lead"
          route="lead"
          allData={allLeads}
          setAllData={setAllLeads}
        />
      )}
    </Paper>
  );
};

export default MainTable;
